import { CKButton, CKModal } from 'clearkit';

import { readableObjectTypeName, readableType } from '~/lib/dataEnrichment';

const SaveFieldMappingModal = ({
  confirmSaveDialogOpen,
  setConfirmSaveDialogOpen,
  objectType,
  integration,
  triggering,
  isUpdating,
  updateFieldMapping,
  input,
}) => {
  return (
    <CKModal
      aria-label="Modal"
      baseId="toggle-field-mapping-modal"
      isVisible={confirmSaveDialogOpen}
      onToggle={() => setConfirmSaveDialogOpen(false)}
      size="md"
    >
      <CKModal.Header>
        <CKModal.Heading>
          Would you like to backfill all{' '}
          {readableObjectTypeName(objectType.name)} with this mapping?
        </CKModal.Heading>
      </CKModal.Header>
      <CKModal.Body className="px-10 py-6">
        <p>
          Without a backfill, you may see inconsistencies in reporting and data
          synced to {readableObjectTypeName(objectType.name)} in{' '}
          {readableType(integration)}
        </p>
      </CKModal.Body>
      <CKModal.Footer className="gap-2">
        <CKButton
          isLoading={triggering || isUpdating}
          onClick={async () => {
            await updateFieldMapping();
            setConfirmSaveDialogOpen(false);
          }}
        >
          No, thanks
        </CKButton>
        <CKButton
          isLoading={triggering || isUpdating}
          onClick={async () => {
            await updateFieldMapping({
              variables: { input: { ...input, backfill: true } },
            });
            setConfirmSaveDialogOpen(false);
          }}
          variant="bold"
          variantColor="blue"
        >
          Start backfill
        </CKButton>
      </CKModal.Footer>
    </CKModal>
  );
};

export default SaveFieldMappingModal;
